/*
* @Author: Wang Shuai
* @Date:   2022-04-13 17:30:54
* @Last Modified by:   Wang Shuai
* @Last Modified time: 2022-04-13 17:34:26
*/
// 平台入驻企业页面的 接口集合
import request from '../request.js'

// 获得入驻企业列表 ---- 李开明
export const getPlatFormTenants = function (data) {
    return request({
        url: 'userTenantCenter/selectTenantPage',
        method: 'post',
        data
    })
}

// 获得入驻企业 当前的 标签信息 ---- 叶凡
export const getObjectTags = function (data) {
    return request({
        url: 'operateTagObject/getObjectTags',
        method: 'post',
        data
    })
}

// 保存入驻企业 当前的 标签信息 ---- 李开明
export const saveObjectTags = function (data) {
    return request({
        url: 'userTenantCenter/saveObjectTags',
        method: 'post',
        data
    })
}


// 查询组织架构 --- 赵建强
export const getOrganization = function(data) {
    return request({
        url: 'userTenantCenter/selectOrganization',
        method: 'post',
        data
    })
}

// 查询组织架构对应的人员 --- 赵建强
export const getAllUser = function(data) {
    return request({
        url: 'userTenantCenter/selectAllPage',
        method: 'post',
        data
    })
}

// 企业组织-查询人员变更记录 --- 叶凡
export const getPageTrans = function(data) {
    return request({
        url: 'userTenantCenter/getPageTrans',
        method: 'post',
        data
    })
}

// 业务板块负责人列表数据 -- 赵建强
export const getBusPrincipals = function(data) {
    return request({
        url: 'userTenantCenter/getBusPrincipals',
        method: 'post',
        data
    })
}

// 查询法人注册或代理人注册公司信息 ---- 赵健强
export const selectCompanyInfo = function (data) {
    return request({
        url: 'userTenantCenter/getTenantById',
        method: 'post',
        data
    })
}

// 用户协议根据应用场景获取协议 --- 赵建强
export const getDealsByScene = function (data) {
    return request({
        url: 'public/getDealsByScene',
        method: 'post',
        data
    })
}

// 入驻企业-更新是否开启平台转付 --- 孙强
export const updateTenantById = function (data) {
    return request({
        url: 'userTenantCenter/updateTenantById',
        method: 'post',
        data
    })
}
